/**
 * Mounts the prospect surface and injects the design system.
 *
 * Two style blocks rather than one: `tokens` is what a customer overrides under D-01, and
 * `surfaceStyles` is what the primitives depend on. Keeping them separate means a retheme is a third
 * block appended after these two, with no `!important` and no specificity fight.
 *
 * Injected here rather than imported as CSS because `@iqz-ddds/components` is consumed as source with
 * no build step, so it makes no bundler assumptions.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { fontFaces, initTheme, surfaceStyles, tokens } from '@iqz-ddds/components';
import { App } from './App';

const style = document.createElement('style');
style.textContent = `${fontFaces}\n${tokens}\n${surfaceStyles}`;
document.head.appendChild(style);

/*
 * Before mounting, so the first paint is already the right colour.
 *
 * Applying a stored preference after React has rendered would show the light palette for a frame
 * to somebody who asked for dark, which is the flash every theme implementation gets wrong once.
 */
initTheme();

const root = document.getElementById('root');
if (root === null) throw new Error('Root element #root is missing from index.html.');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
